// -- React Libraries
import React from 'react';
import MediaQuery from 'react-responsive';

// -- Styles
import StyleWrapper from "./Wrapper";

export default class AppHeader extends React.Component {
    ConvertToPriceString(currency, price) {
        if (price == null || price == undefined) return "-";
        try { if (parseInt(price) <= 0) return "免费"; }
        catch(ex) { }
        return '收费';

        if (currency) return currency + " " + price;
        return price;
    }

    ConcatToGenresString (genres) {
        var translatedGenres = genres || [];
        translatedGenres = translatedGenres.map( function (genre) {
            if (!genre || genre.length <= 0) return '';
            switch (genre.toLowerCase()) {
                case 'games': return '游戏';
                case 'shopping': return '购物';
                case 'photo & video': return '摄影与录像';
                case 'education': return '教育';
                case 'kids': return '儿童';
                case 'lifestyle': return '生活';
                case 'health & fitness': return '健康';
                case 'productivity': return '效率';
                case 'magazines & newspapers': return '报刊杂志';
                case 'travel': return '旅游';
                case 'music': return '音乐';
                case 'sports': return '体育';
                case 'entertainment': return '娱乐';
                case 'news': return '新闻';
                case 'social networking': return '社交';
                case 'business': return '商务';
                case 'utilities': return '工具';
                case 'books': return '图书';
                case 'finance': return '财务';
                case 'food & drink': return '美食佳饮';
                case 'medical': return '医疗';
                case 'navigation': return '导航';
                case 'reference': return '参考';
                case 'weather': return '天气';
                case 'developer tool': return '开发者工具"';
            }

            return genre;
        }).filter( (genre) => genre.length > 0);
        return translatedGenres ? translatedGenres.join("/") : "";
    }

    ConvertToDateString (date) {
        if (!date) return "";

        var DateInstance = new Date(date);
        return `${DateInstance.getFullYear()}年${DateInstance.getMonth()+1}月${DateInstance.getDate()}日`;
        var monthName = DateInstance.toLocaleString("zh-cn", { month: "long" });
        
        if (monthName.length > 3) monthName = monthName.substr(0, 3);
        return monthName + " " + DateInstance.getDate() + ", " + DateInstance.getFullYear();
    }

    GetAppDetails (props) {
        return (
            <div className="app-details">
                <div>开发商： {props.publisher}</div>
                <div>
                    价格： {this.ConvertToPriceString(props.currency, props.price)} |
                    类别: {this.ConcatToGenresString(props.category)}
                </div>
                <div>
                    版本： {props.version} |
                    发行日期： {this.ConvertToDateString(props.releaseDate)} |
                    最后更新日期： {this.ConvertToDateString(props.lastUpdated)}
                </div>
            </div>
        );
    }

    render() {
        return (
            <StyleWrapper className="app-header">
                <div className="app-info">
                    <div className="app-icon-container">
                        <img src={this.props.imgUrl} />
                    </div>

                    <div className="app-description">
                        <div className="app-name">{this.props.appName}</div>

                        <MediaQuery minWidth={768}>
                            {this.GetAppDetails(this.props)}
                        </MediaQuery>
                    </div>
                </div>

                <MediaQuery maxWidth={767}>
                    {this.GetAppDetails(this.props)}
                </MediaQuery>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppHeader/index.js